import React, { useContext, useState } from 'react';
import axios from 'axios';
import { Helmet } from 'react-helmet';

import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Layout from '../components/Layout';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import strings from '../utility/strings.js';
import swal from 'sweetalert';
import {useAppState} from '../../index.js';

const Feedback = (props) => {
  const { AppContext } = props;
  const { styleprops } = useContext(AppContext);
  const [area, setArea] = useState("");
  const [email, setEmail] = useState("");
  const [frequent, setFrequent] = useState("");
  const [improvements, setImprovements] = useState("");
  const [rating, setRating] = useState("");
  const [relationship, setRelationship] = useState("");
  const [errorEmail, setErrorEmail] = useState(false);
  const [sending, setSending] = useState(false);

  function validateEmailAddress(event) {
    setEmail(event.target.value);
    let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (re.test(event.target.value)) {
      // this is a valid email address false means email is valid
      setErrorEmail(false);
    }
    else {
      // invalid email, maybe show an error to the user.
      setErrorEmail(true);
    }
  }

  function handleSend() {
    if (frequent !== "" ||
      area !== "" ||
      rating !== "" ||
      relationship !== "" ||
      improvements !== "" ||
      email !== "") {
      setSending(true);
      //use axios to send an email through webform mailer.
      let instance = axios.create();
      instance.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
      instance({
        method: 'post',
        url: 'https://www.hfs.purdue.edu/WebFormMailer/FormMailer/Process/74d279ea-5ecb-4bce-bbd3-d0f9a6b45974',
        data: "E-Mail=" + email
          + "&FeedbackArea=" + area
          + "&MenusRating=" + rating
          + "&UsageFrequency=" + frequent
          + "&RelationshipToPurdue=" + relationship
          + "&Improvements=" + improvements
          + "&SiteVersion=v" + strings.version,
      })
        .then(() => {
          swal("Thanks!", "Your feedback was submitted!", "success");
          //reset form state
          setSending(false);
          setEmail("");
          setRating("");
          setArea("");
          setFrequent("");
          setRelationship("");
          setImprovements("");
        })
        .catch((error) => {
          console.log("Error Message: ", error);
          swal("Sorry about that!", "We've encountered an error, please try again.", "error");
          //reset sending state
          setSending(false);
        })
    }
  };

  let ratingScale = ["Love It", "Like It", "Neutral", "Don't like it", "Hate It"];
  let classifications = ["Student - Undergraduate", "Student - Graduate", "Faculty", "Staff", "Other"];
  let frequency = ["Daily", "Weekly", "Monthly", "Rarely", "Other"];
  let areas = ["Purdue Dining Courts", "Purdue Retail Dining", "Dining Menus Website/Apps", "Specific Menu Item", "General Feedback"];
  return (
    <main className={"mdl-layout__content"} id="main" style={{ ...styleprops, paddingTop: 68 }}>
      <div className="md-feedback__description">You can use the form below to send us feedback about your Purdue Dining experience, leave ideas and feedback about the website or apps, or contact us about any issues you may encounter.</div>
      <div className="md-feedback">
        <div className={sending ? "md-feedback__column md-feedback__inprogress--disabled" : "md-feedback__column"}>
          <FormControl style={{ marginTop: 30 }}>
            <InputLabel id='area-label' htmlFor="area-form">What area are you giving feedback on?</InputLabel>
            <Select
              value={area}
              onChange={(event) => setArea(event.target.value)}
              label="What area are you giving feedback on?"
              labelId="area-label"
              id="area-form"
            >
              <MenuItem key={"empty0"} value={""}>
                N/A
              </MenuItem>
              {areas.map(function (x, i) {
                return <MenuItem key={i} value={x}>
                  {x}
                </MenuItem>
              })}
            </Select>
          </FormControl>
          <FormControl style={{ marginTop: 40 }} >
            <InputLabel id='rate-label' htmlFor="rate-form">How would you rate Purdue Dining Menus?</InputLabel>
            <Select
              label="How would you rate Purdue Dining Menus?"
              labelId="rate-label"
              id="rate-form"
              value={rating}
              onChange={(event) => setRating(event.target.value)}
            >
              <MenuItem key={"empty0"} value={""}>
                N/A
              </MenuItem>
              {ratingScale.map(function (x, i) {
                return <MenuItem key={i} value={x}>
                  {x}
                </MenuItem>
              })}
            </Select>
          </FormControl>
          <FormControl style={{ marginTop: 50 }}>
            <InputLabel id='frequent-label' htmlFor="frequent-form">How often do you use Purdue Dining Menus?</InputLabel>
            <Select
              label="How often do you use Purdue Dining Menus?"
              labelId="frequent-label"
              id="frequent-form"
              value={frequent}
              onChange={(event) => setFrequent(event.target.value)}
            >
              <MenuItem key={"empty0"} value={""}>
                N/A
              </MenuItem>
              {frequency.map(function (x, i) {
                return <MenuItem key={i} value={x}>
                  {x}
                </MenuItem>
              })}
            </Select>
          </FormControl>
        </div>
        <div className={sending ? "md-feedback__column md-feedback__inprogress--disabled" : "md-feedback__column"}>
          <FormControl style={{ marginTop: 30 }}>
            <InputLabel id='relationship-label' htmlFor="relationship-form">What is your relationship to Purdue?</InputLabel>
            <Select
              label="What is your relationship to Purdue?"
              labelId="relationship-label"
              id="relationship-form"
              value={relationship}
              onChange={(event) => setRelationship(event.target.value)}
            >
              <MenuItem key={"empty0"} value={""}>
                N/A
              </MenuItem>
              {classifications.map(function (x, i) {
                return <MenuItem key={i} value={x}>
                  {x}
                </MenuItem>
              })}
            </Select>
          </FormControl>
          <FormControl style={{ marginTop: 40 }} >
            <TextField
              id="email"
              name="email"
              type="email"
              required
              error={errorEmail}
              helperText={errorEmail ? "Please enter a valid email address." : "Required"}
              value={email}
              label="Contact E-mail"
              placeholder="john@purdue.edu"
              onChange={validateEmailAddress}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </FormControl>
          <FormControl style={{ marginTop: 30 }}>
            <TextField
              id="improvements"
              label="How can we improve?"
              name="improvements"
              multiline
              value={improvements}
              onChange={(event) => setImprovements(event.target.value)}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </FormControl>
        </div>
        <div className={sending ? "md-feedback__row md-feedback--inprogress" : "md-feedback__row"}>
          <Button variant="contained" disabled={email && errorEmail === false ? false : true} onClick={() => handleSend()} color="primary">
            Leave Feedback
          </Button>
          <div className={'md-feedback--sending'}>
            Sending
          </div>
        </div>
      </div>
    </main>
  )
}

// Use a feedback layer to pass props to the view
const FeedbackLayout = (props) => {
  const {locations, currentUser, GET_USER} = useAppState();
  const { AppContext } = props
  return (
    <>
      <Helmet>
        <title>Feedback - Purdue Dining Menus</title>
        <meta name="description" content="Send feedback about your Purdue Dining experience, website suggestions, or report issues with the dining menus." />
        <meta name="keywords" content="Purdue dining feedback, restaurant feedback, food service comments, dining suggestions" />
        <meta property="og:title" content="Feedback - Purdue Dining" />
        <meta property="og:description" content="Send feedback about your Purdue Dining experience and help us improve our services." />
      </Helmet>
      <Layout AppContext={AppContext} locations={locations} currentUser={currentUser} GET_USER={GET_USER} pageName="Feedback">
        <Feedback AppContext={AppContext} locations={locations} currentUser={currentUser} GET_USER={GET_USER} />
      </Layout>
    </>
  )
}

export default FeedbackLayout;